

/**
 * Listens for changes to the CourseProperties object and save data back to the LMS accordingly
 */
window.CustomTracking = Backbone.Model.extend(
{
	initialize: function () {
		this.courseProperties = new CourseProperties();
		this.interactionProperties = new InteractionProperties({ scorm: this.scorm });
		this.useCompression = this.attributes.useCompression ? true : false;
		if (this.attributes.timerInterval) this.timerInterval = this.attributes.timerInterval;
				
		this.scorm = new GenericStorageInterface();
		this.cmi = new CMI();
		this.cmi.initialise("1.2");
		this.timer = new Timer({ timerInterval: this.timerInterval });
		this.timer.bind("onTimerTick", function (e) {
			var time = this.timer.getTime();
			var formattedTime = this.scorm.formatTime(time);

			this.courseProperties.setCmiData("SESSION_TIME", this.cmi.labels["SESSION_TIME"], String(formattedTime));

		}, this);
		
		this.timer.start();

		this.assignPropertiesIfFirstRun();
	},

	start: function () {
		this.trigger("onInitComplete", {});
	},

	assignPropertiesIfFirstRun: function () {
		var lessonStatus = this.getCmiData("LESSON_STATUS");
		var acceptableValues = [
			'passed', 
			'failed', 
			'completed',
			'started',
			'not-incomplete',
			'incomplete'
		];
		// Update the lesson status if this is the first launch of the content
		if ( !acceptableValues.includes( lessonStatus ) ) {
			// this.courseProperties.setCmiData("LESSON_STATUS", this.cmi.labels["LESSON_STATUS"], "incomplete");
			this.setCmiData("LESSON_STATUS", "incomplete");
		}
	},

	getItem: function (label) {
		return this.courseProperties.getItem(label);
	},

	setItem: function (label, value) {
		this.courseProperties.setItem(label, value);
	},

	deleteItem: function (label) {
		this.courseProperties.deleteItem(label);
	},

	deleteAllItems: function (label) {
		this.courseProperties.clearSuspendData();
	},

	getCmiData: function (label) {
		return this.courseProperties.getCmiData(this.cmi.labels[label]);
	},

	setCmiData: function (label, value) {
		this.courseProperties.setCmiData(label, this.cmi.labels[label], value);
	},

	deleteAllCmiItems: function (label) {
		this.courseProperties.clearCmiData();
	},

	setInteraction: function (data) {
		this.interactionProperties.setInteraction(data);
	},

	save: function () {
		// Tracking.debug("tracking.save()");

		// this.trigger("onBeforeSave");

		// // Create the data string based on the [this.useCompression] variable
		// var data = this.useCompression ? LZString.compressToUTF16(this.courseProperties.getDataAsString()) : this.courseProperties.getDataAsString();

		// this.scorm.set(this.cmi.labels["SUSPEND_DATA"], data);

		// Logger.trace("Suspend data length: ", data.length);
		// Logger.trace("Score: ", this.getCmiData("SCORE_RAW"));
		// Logger.trace("Lesson status: ", this.getCmiData("LESSON_STATUS"));

		// if (this.scorm.commit()) {
		// 	this.trigger("onSaveSuccess");

		// } else {
		// 	this.trigger("onSaveFail");
		// }

	},

	load: function () {
		// for (var i in this.cmi.labels) {
		// 	this.courseProperties.setCmiData(i, this.cmi.labels[i], this.scorm.get(this.cmi.labels[i]));
		// }

		// // if interaction count > 0... add to course properties

		// var suspendData = this.scorm.get(this.cmi.labels["SUSPEND_DATA"])

		// // Extract the data string based on the [this.useCompression] variable
		// var data = this.useCompression ? LZString.decompressFromUTF16(suspendData) : suspendData;

		// this.courseProperties.extractDataAsString(data);
	},

	reset: function () {
		// this.setCmiData("SUSPEND_DATA", " ");
		// this.setCmiData("LESSON_STATUS", "incomplete");
	},

	clear: function () {
		this.deleteAllCmiItems();
		this.deleteAllItems();

		this.trigger("onClear");
	},

	finish: function () {
		// this.save();
		// this.scorm.set(this.cmi.labels["EXIT"], "suspend"); // Setting cmi.exit to “suspend” will ensure that the current attempt is preserved and the run-time data is not reset the next time the SCO is launched.
		// this.scorm.finish();
		return;
	},

	getDataAsString: function () {
		return this.courseProperties.getDataAsString();
	},

	getCmiDataAsString: function () {
		return this.courseProperties.getCmiDataAsString();
	},

	extractDataAsString: function () {
		return this.courseProperties.extractDataAsString();
	}

},
{
	debug: function (message) {
		// Logger.trace("Tracking:: " + message) // Not sure we're logging anything useful here?
	}

});
